/**
 * Created by yz on 2017/3/23.
 */
{
    angular
        .module("dataModule")
        .factory("requestHandler", requestHandler);
    requestHandler.$inject = ["$http","utils.constant"];
    function requestHandler($http,constant) {
        let collect={
            'sendRequest':sendRequest,
            'simpleRequest':simpleRequest,
            'errorManage':errorManage
        };

        return collect;

        function sendRequest(method,url, paramData,successCallback,errorCallback){
            // console.log(url);
            let requestConfig = {
                'method': method,
                'url': url,
                'headers': {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            };
            //fhq:参数数据要以字符串的形式传给后台。
            // console.log(paramData)
            if (typeof(paramData) === 'string') {
                requestConfig.data = paramData;
            } else {
                let paramsStr='';
                for(let key in paramData||{}){
                    if(paramsStr!=''){
                        paramsStr=paramsStr+'&';
                    }
                    paramsStr=paramsStr+key+'='+paramData[key];
                }
                requestConfig.data = paramsStr;
            }

            let promise = $http(requestConfig)
                .then(function (response) {
                        //fhq:访问成功
                        let callback=successCallback||function(){};
                        let promise=callback(response);
                        if(typeof(promise)==='undefined'){
                            return response;
                        }else{
                            return promise;
                        }
                        
                    },
                    function (response){
                        //fhq:访问失败
                        // console.log('http error\n',response);
                        let callback=errorCallback||errorManage;
                        let promise=callback(response);
                        if(typeof(promise)==='undefined'){
                            throw response;
                        }else{
                            return promise;
                        }
                    });
                // .then(function(){console.log('s')},function(){console.log('f')});
            return promise;
        }
         //简单请求：action：请求接口     paramData：传给后台的数据
        function simpleRequest(action, paramData,successCallback,errorCallback) {
            return sendRequest('POST',
                constant.config.sitePath + action,
                 paramData,
                 successCallback,
                 errorCallback);
        }

        function errorManage(response ){
            // console.log("请求失败",response);
        }


    }

}